import * as angular from 'angular';
import { PagingSetting } from '../custom';

export class ReportingStorageService {
    private keys: string[];
    private reportingStorageKey: string;
    private unitParamKey: string;

    constructor(private storageService) {
        this.unitParamKey = 'reportFilter-unitParam';
        this.reportingStorageKey = 'reporting-Storage-Service';
        this.keys = [];

        let keysFromSession = this.fetchFromSession(this.reportingStorageKey);
        if (!!keysFromSession) {
            this.keys = keysFromSession;
        }
    }

    clearReportingStorage(): void {
        angular.forEach(this.keys, (key) => {
            this.storageService.removeFromSession(key);
        });
        this.keys = [];
        this.storageService.storeToSession(this.reportingStorageKey, this.keys);
    }

    storeToSession(key: string, value: any): void {
        this.storageService.storeToSession(key, value);
        if (this.keys.indexOf(key) === -1) {
            this.keys.push(key);
        }
        this.storageService.storeToSession(this.reportingStorageKey, this.keys);
    }

    fetchFromSession(key: string): any {
        return this.storageService.fetchFromSession(key);
    }

    removeFromSession(key: string): void {
        this.storageService.removeFromSession(key);
        let index = this.keys.indexOf(key);
        if (index !== -1) {
            this.keys.splice(index, 1);
        }
        this.storageService.storeToSession(this.reportingStorageKey, this.keys);
    }

    /**
     * Fetch object with amount, cost and pageSize settings.
     * @returns {*}
     */
    fetchPagingSettingFromSession(): PagingSetting {
        return this.fetchFromSession(this.unitParamKey);
    }

    /**
     * Stores object with amount, cost and pageSize settings.
     * @returns {*}
     */
    storePagingSettingToSession(value: PagingSetting): void {
        this.storeToSession(this.unitParamKey, value);
    }
}

/**
 * @ngdoc service
 * @name reportingStorageService
 * @memberof app
 *
 * @description Handles the session storage for the whole reporting area.
 *
 * @author somarten.btc
 */
angular
    .module('app')
    .service('reportingStorageService', ReportingStorageService);
